import { ThemeProvider } from "styled-components";
import { theme } from "./styles/Theme";
import AppRouter from "./AppRouter";
import GlobalStyle from "./styles/GlobalStyle";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import { AuthProvider } from "./context/AuthContext";
import { PressKitProvider } from "./context/PressKitContext";
import { GlobalLoadingProvider } from "./components/loading/GlobalLoading";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <PressKitProvider>
          <GlobalStyle />
          <GlobalLoadingProvider>
            <ScrollToTop />
            <AppRouter />
          </GlobalLoadingProvider>
        </PressKitProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
